/* FalcX install page (r7, fit-install). Tick boxes kept on this device for 3 days (localStorage, one key), progress per
   part and overall, "Clear ticks", Print (opens every "Stuck?" answer for the printout), the phone "Jump to" bar
   (closes after a jump, names the part on screen), contents column highlighting, and "Back to …" for a visit from a
   product page. Everything works without it: the boxes tick, the links jump, the answers open. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.FalcxInstall = api; if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', api.boot); else api.boot(); }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var STORE = 'falcx-install-ticks-v1';
  var TTL = 3 * 24 * 60 * 60 * 1000;
  /* {t: last change (ms), done: {key: 1}}. Anything unreadable or older than the TTL starts empty. */
  function load(raw, now, ttl) {
    var empty = {t: now, done: {}};
    if (!raw) return empty;
    try {
      var o = JSON.parse(raw);
      if (!o || typeof o !== 'object' || typeof o.t !== 'number' || !o.done || typeof o.done !== 'object') return empty;
      if (now - o.t > (ttl || TTL) || o.t > now + 60000) return empty;
      var done = {};
      Object.keys(o.done).forEach(function (k) { if (o.done[k]) done[k] = 1; });
      return {t: o.t, done: done};
    } catch (e) { return empty; }
  }
  function set(state, key, on, now) {
    var done = {};
    Object.keys(state.done).forEach(function (k) { done[k] = 1; });
    if (on) done[key] = 1; else delete done[key];
    return {t: now, done: done};
  }
  /* boxes: [{key, part}] -> {all: {done, total}, parts: {front: {done, total}}} */
  function progress(boxes, state) {
    var out = {all: {done: 0, total: 0}, parts: {}};
    boxes.forEach(function (b) {
      var p = out.parts[b.part] || (out.parts[b.part] = {done: 0, total: 0});
      var on = !!state.done[b.key];
      p.total++; out.all.total++;
      if (on) { p.done++; out.all.done++; }
    });
    return out;
  }
  function partLabel(p) { return p && p.total ? (p.done === p.total ? 'Done' : p.done + '/' + p.total) : ''; }
  function countLabel(all) {
    if (!all.total) return 'Tick each step off as you go.';
    if (all.done === 0) return 'Tick each step off as you go. Ticks stay on this device for 3 days.';
    if (all.done === all.total) return 'All ' + all.total + ' ticked.';
    return all.done + ' of ' + all.total + ' ticked. Ticks stay on this device for 3 days.';
  }
  function backTarget(referrer, origin) {
    if (!referrer) return null;
    var u;
    try { u = new URL(referrer); } catch (e) { return null; }
    if (u.origin !== origin) return null;
    if (/^\/products\/[^/]+\/?$/.test(u.pathname)) return {href: u.pathname + u.search, kind: 'product', json: u.pathname.replace(/\/$/, '') + '.js'};
    if (/^\/collections\//.test(u.pathname)) return {href: u.pathname + u.search, kind: 'collection'};
    if (u.pathname === '/pages/fitment') return {href: u.pathname + u.search, kind: 'fitment'};
    return null;
  }

  /* Horizon scrolls .page-wrapper, not the window, so the browser's own jump to /pages/…#rear on load does not happen
     and smooth in-page jumps can stall: scroll the target into view here (scroll-margin keeps it clear of the header). */
  function jumpTo(id, smooth) {
    var el = id && document.getElementById(id);
    if (!el) return null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({behavior: smooth && !reduce ? 'smooth' : 'instant', block: 'start'});
    return el;
  }
  function jumpOnLoad() {
    var id = decodeURIComponent((window.location.hash || '').slice(1));
    if (!id || !document.getElementById(id)) return;
    var moved = false;
    function stop() { moved = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.addEventListener(t, stop, {once: true, passive: true}); });
    setTimeout(function () { jumpTo(id, false); }, 0);
    /* Images above the target can still change the layout until the page has loaded. */
    window.addEventListener('load', function () { if (!moved) jumpTo(id, false); });
  }

  function boot() {
    var page = document;
    if (!document.querySelector('[data-fxi-part]')) return;
    var boxes = Array.prototype.slice.call(page.querySelectorAll('input[data-fxi-check]'));
    var list = boxes.map(function (b) { return {key: b.getAttribute('data-fxi-check'), part: b.getAttribute('data-part') || ''}; });
    var raw = null;
    try { raw = localStorage.getItem(STORE); } catch (e) { /* blocked */ }
    var state = load(raw, Date.now());
    boxes.forEach(function (b) { b.checked = !!state.done[b.getAttribute('data-fxi-check')]; mark(b); });
    var status = document.querySelector('[data-fxi-status]');
    function save() { try { if (Object.keys(state.done).length) localStorage.setItem(STORE, JSON.stringify(state)); else localStorage.removeItem(STORE); } catch (e) { /* blocked */ } }
    function mark(b) { var step = b.closest('.fxi-step, .fxi-checklist li'); if (step) step.classList.toggle('is-done', b.checked); }
    function paint() {
      var pr = progress(list, state);
      page.querySelectorAll('[data-fxi-progress]').forEach(function (el) {
        var t = partLabel(pr.parts[el.getAttribute('data-fxi-progress')]);
        if (el.textContent !== t) el.textContent = t;
        el.classList.toggle('is-done', t === 'Done');
      });
      var c = page.querySelector('[data-fxi-count]');
      if (c) c.textContent = countLabel(pr.all);
      var clear = page.querySelector('[data-fxi-clear]');
      if (clear) clear.disabled = pr.all.done === 0;
    }
    document.addEventListener('change', function (e) {
      var b = e.target;
      if (!b || !b.matches || !b.matches('input[data-fxi-check]')) return;
      state = set(state, b.getAttribute('data-fxi-check'), b.checked, Date.now());
      mark(b); save(); paint();
    });
    var clear = page.querySelector('[data-fxi-clear]');
    if (clear) clear.addEventListener('click', function () {
      state = {t: Date.now(), done: {}};
      boxes.forEach(function (b) { b.checked = false; mark(b); });
      save(); paint();
      if (status) status.textContent = 'All ticks cleared.';
    });
    var print = page.querySelector('[data-fxi-print]');
    if (print && window.print) print.addEventListener('click', function () { window.print(); });
    /* The printout carries every "Stuck?" answer. */
    var opened = [];
    window.addEventListener('beforeprint', function () { opened = []; document.querySelectorAll('details.fxi-q:not([open])').forEach(function (d) { d.open = true; opened.push(d); }); });
    window.addEventListener('afterprint', function () { opened.forEach(function (d) { d.open = false; }); opened = []; });
    paint();

    /* Jumping: close the phone bar, move focus to the heading so the next swipe or Tab starts there. */
    var jump = page.querySelector('[data-fxi-jump]');
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1));
      if (jump && jump.contains(a)) jump.open = false;
      var target = jumpTo(id, true);
      if (!target) return;
      e.preventDefault();
      if (window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.search + '#' + id);
      var head = target.querySelector('h2[tabindex]');
      if (head) setTimeout(function () { try { head.focus({preventScroll: true}); } catch (err) { /* old browser */ } }, 0);
    });
    jumpOnLoad();
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && jump && jump.open) { jump.open = false; var s = jump.querySelector('summary'); if (s) s.focus(); } });

    /* Which part is on screen: the jump bar names it, the contents column marks it. */
    var parts = Array.prototype.slice.call(page.querySelectorAll('[data-fxi-part]'));
    var now = page.querySelector('[data-fxi-now]');
    var tocnav = page.querySelector('[data-fxi-tocnav]');
    if ('IntersectionObserver' in window && parts.length) {
      var seen = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting; });
        var cur = null;
        for (var i = 0; i < parts.length; i++) if (seen[parts[i].id]) { cur = parts[i]; break; }
        if (!cur) return;
        if (now) now.textContent = cur.getAttribute('data-fxi-label') || '';
        page.querySelectorAll('[data-fxi-toc]').forEach(function (l) {
          if (l.getAttribute('data-fxi-toc') === cur.id) l.setAttribute('aria-current', 'location'); else l.removeAttribute('aria-current');
        });
      }, {rootMargin: '-35% 0px -60% 0px'});
      parts.forEach(function (p) { io.observe(p); });
      /* The bar shows once the contents list at the top is off screen. */
      if (jump && tocnav) {
        var bar = new IntersectionObserver(function (entries) {
          var off = entries[0] && !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          jump.classList.toggle('is-on', !!off);
          if (!off) jump.open = false;
        });
        bar.observe(tocnav);
      }
    } else if (jump) jump.classList.add('is-on');

    back(page.querySelector('[data-fx-back]'));
  }
  function back(link) {
    if (!link) return;
    var t = backTarget(document.referrer, window.location.origin);
    if (!t) return;
    link.href = t.href;
    var label = link.querySelector('[data-fx-back-label]') || link;
    label.textContent = t.kind === 'product' ? 'Back to the product' : t.kind === 'fitment' ? 'Back to fitment' : 'Back to the shop';
    if (t.kind === 'product' && window.fetch) {
      fetch(t.json, {headers: {Accept: 'application/json'}}).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p && p.title) label.textContent = 'Back to ' + p.title;
      }).catch(function () {});
    }
  }
  return {load: load, set: set, progress: progress, partLabel: partLabel, countLabel: countLabel, backTarget: backTarget, boot: boot, TTL: TTL, STORE: STORE};
}));